//#region src/styles/tokens.css.ts
var e = {
	font: {
		familyDisplay: "var(--font-family-display)",
		familyNumber: "var(--font-family-number)"
	},
	text: {
		secondaryOnBrand: "var(--text-secondary-on-brand)",
		warning: "var(--text-warning)",
		action: "var(--text-action)",
		tagPurple: "var(--text-tag-purple)",
		tagGreen: "var(--text-tag-green)",
		tagRed: "var(--text-tag-red)",
		tagBlue: "var(--text-tag-blue)",
		tagYellow: "var(--text-tag-yellow)",
		tagOrange: "var(--text-tag-orange)",
		tagGrey: "var(--text-tag-grey)",
		tagLightGrey: "var(--text-tag-light-grey)",
		tagLime: "var(--text-tag-lime)",
		progress: "var(--text-progress)",
		tagTeal: "var(--text-tag-teal)",
		navigation: "var(--text-navigation)",
		navigationActive: "var(--text-navigation-active)",
		primary: "var(--text-primary)",
		primaryOnBrand: "var(--text-primary-on-brand)",
		secondary: "var(--text-secondary)",
		tertiary: "var(--text-tertiary)",
		disabled: "var(--text-disabled)",
		brandMain: "var(--text-brand-main)",
		brandAccent: "var(--text-brand-accent)",
		brandAccentDarker: "var(--text-brand-accent-darker)",
		black: "var(--text-black)",
		white: "var(--text-white)",
		error: "var(--text-error)",
		errorSubtle: "var(--text-error-subtle)",
		success: "var(--text-success)",
		onProgress: "var(--text-on-progress)",
		toggleOff: "var(--text-toggle-off)",
		toggleOn: "var(--text-toggle-on)",
		toggleDisabled: "var(--text-toggle-disabled)"
	},
	border: {
		disabled: "var(--border-disabled)",
		error: "var(--border-error)",
		action: "var(--border-action)",
		brandMain: "var(--border-brand-main)",
		black: "var(--border-black)",
		white: "var(--border-white)",
		primary: "var(--border-primary)",
		secondary: "var(--border-secondary)",
		tertiary: "var(--border-tertiary)",
		brandAccent: "var(--border-brand-accent)",
		onBrandMain: "var(--border-on-brand-main)",
		accent15: "var(--border-accent-15)",
		autopilot: "var(--border-autopilot)"
	},
	fg: {
		primary: "var(--fg-primary)",
		secondary: "var(--fg-secondary)",
		disabled: "var(--fg-disabled)",
		brandMain: "var(--fg-brand-main)",
		error: "var(--fg-error)",
		warning: "var(--fg-warning)",
		action: "var(--fg-action)",
		textSelect: "var(--fg-text-select)",
		teal: "var(--fg-teal)",
		navigation: "var(--fg-navigation)",
		navigationActive: "var(--fg-navigation-active)",
		navigationLogo: "var(--fg-navigation-logo)",
		white: "var(--fg-white)",
		black: "var(--fg-black)",
		tertiary: "var(--fg-tertiary)",
		brandAccent: "var(--fg-brand-accent)",
		brandAccentDarker: "var(--fg-brand-accent-darker)",
		progress: "var(--fg-progress)",
		success: "var(--fg-success)",
		toggle: "var(--fg-toggle)",
		toggleHover: "var(--fg-toggle-hover)",
		togglePressed: "var(--fg-toggle-pressed)",
		toggleThumb: "var(--fg-toggle-thumb)",
		tennis50: "var(--fg-tennis-50)",
		tennis100: "var(--fg-tennis-100)"
	},
	bg: {
		primaryHover: "var(--bg-primary-hover)",
		secondaryFocused: "var(--bg-secondary-focused)",
		active: "var(--bg-active)",
		brandMain: "var(--bg-brand-main)",
		errorLight: "var(--bg-error-light)",
		errorDark: "var(--bg-error-dark)",
		warning: "var(--bg-warning)",
		success: "var(--bg-success)",
		action: "var(--bg-action)",
		tagRed: "var(--bg-tag-red)",
		tagBlue: "var(--bg-tag-blue)",
		tagOrange: "var(--bg-tag-orange)",
		tagLime: "var(--bg-tag-lime)",
		teal: "var(--bg-teal)",
		tagTeal: "var(--bg-tag-teal)",
		brandFocused: "var(--bg-brand-focused)",
		whiteHover: "var(--bg-white-hover)",
		whiteFocused: "var(--bg-white-focused)",
		navigationItemHover: "var(--bg-navigation-item-hover)",
		navigationItemActive: "var(--bg-navigation-item-active)",
		primary: "var(--bg-primary)",
		secondary: "var(--bg-secondary)",
		secondaryHover: "var(--bg-secondary-hover)",
		disabled: "var(--bg-disabled)",
		overlay: "var(--bg-overlay)",
		brandAccent: "var(--bg-brand-accent)",
		brandHover: "var(--bg-brand-hover)",
		brandNavigation: "var(--bg-brand-navigation)",
		brandLaunch: "var(--bg-brand-launch)",
		tagGrey: "var(--bg-tag-grey)",
		tagLightGrey: "var(--bg-tag-light-grey)",
		tagGreen: "var(--bg-tag-green)",
		tagYellow: "var(--bg-tag-yellow)",
		tagPurple: "var(--bg-tag-purple)",
		transparentHighAgent: "var(--bg-transparent-high-agent)",
		transparentLowAgent: "var(--bg-transparent-low-agent)",
		transparentLowest: "var(--bg-transparent-lowest)",
		progress: "var(--bg-progress)",
		toggleOff: "var(--bg-toggle-off)",
		toggleDisabled: "var(--bg-toggle-disabled)"
	},
	accent: { navigationLogo: "var(--accent-navigation-logo)" },
	shadow: { toggleFocus: "var(--shadow-toggle-focus)" },
	graphic: {
		partnershipBronze: "var(--graphic-partnership-bronze)",
		partnershipSilver: "var(--graphic-partnership-silver)",
		partnershipGold: "var(--graphic-partnership-gold)",
		partnershipPlatinum: "var(--graphic-partnership-platinum)",
		partnershipXBlack: "var(--graphic-partnership-x-black)",
		partnershipXWhite: "var(--graphic-partnership-x-white)",
		partnershipBronzeDarker: "var(--graphic-partnership-bronze-darker)",
		partnershipSilverDarker: "var(--graphic-partnership-silver-darker)",
		partnershipGoldDarker: "var(--graphic-partnership-gold-darker)",
		partnershipPlatinumDarker: "var(--graphic-partnership-platinum-darker)",
		partnershipXLighter: "var(--graphic-partnership-x-lighter)",
		statusBgBlue: "var(--graphic-status-bg-blue)",
		statusProgressBlue: "var(--graphic-status-progress-blue)",
		statusIconBlue: "var(--graphic-status-icon-blue)",
		statusIconPurple: "var(--graphic-status-icon-purple)",
		statusProgressPurple: "var(--graphic-status-progress-purple)",
		statusBgPurple: "var(--graphic-status-bg-purple)",
		statusIconGreen: "var(--graphic-status-icon-green)",
		statusProgressGreen: "var(--graphic-status-progress-green)",
		statusBgGreen: "var(--graphic-status-bg-green)",
		statusIconOrange: "var(--graphic-status-icon-orange)",
		statusProgressOrange: "var(--graphic-status-progress-orange)",
		statusBgOrange: "var(--graphic-status-bg-orange)",
		statusBgYellow: "var(--graphic-status-bg-yellow)",
		statusIconYellow: "var(--graphic-status-icon-yellow)",
		statusProgressYellow: "var(--graphic-status-progress-yellow)",
		statusIconRed: "var(--graphic-status-icon-red)",
		statusProgressRed: "var(--graphic-status-progress-red)",
		statusBgRed: "var(--graphic-status-bg-red)",
		statusIconGrey: "var(--graphic-status-icon-grey)",
		statusProgressGrey: "var(--graphic-status-progress-grey)",
		statusBgGrey: "var(--graphic-status-bg-grey)",
		statusIconTeal: "var(--graphic-status-icon-teal)",
		statusProgressTeal: "var(--graphic-status-progress-teal)",
		statusBgTeal: "var(--graphic-status-bg-teal)",
		illustrationFillDarkest: "var(--graphic-illustration-fill-darkest)",
		illustrationFillLight: "var(--graphic-illustration-fill-light)",
		illustrationFillLightest: "var(--graphic-illustration-fill-lightest)",
		illustrationFillDark: "var(--graphic-illustration-fill-dark)",
		illustrationFill70: "var(--graphic-illustration-fill-70)",
		illustrationFill50: "var(--graphic-illustration-fill-50)",
		illustrationFill30: "var(--graphic-illustration-fill-30)",
		animationBg: "var(--graphic-animation-bg)",
		animationToggleOutline: "var(--graphic-animation-toggle-outline)",
		animationToggleFill: "var(--graphic-animation-toggle-fill)",
		animationAccent: "var(--graphic-animation-accent)",
		animationIcon: "var(--graphic-animation-icon)",
		animationText: "var(--graphic-animation-text)"
	},
	typography: {
		heading2xlFontFamily: "var(--typography-heading-2xl-font-family)",
		heading2xlFontSize: "var(--typography-heading-2xl-font-size)",
		heading2xlLineHeight: "var(--typography-heading-2xl-line-height)",
		heading2xlFontWeight: "var(--typography-heading-2xl-font-weight)",
		headingLgFontFamily: "var(--typography-heading-lg-font-family)",
		headingLgFontSize: "var(--typography-heading-lg-font-size)",
		headingLgLineHeight: "var(--typography-heading-lg-line-height)",
		headingLgFontWeight: "var(--typography-heading-lg-font-weight)",
		headingXsFontFamily: "var(--typography-heading-xs-font-family)",
		headingXsFontSize: "var(--typography-heading-xs-font-size)",
		headingXsLineHeight: "var(--typography-heading-xs-line-height)",
		headingXsFontWeight: "var(--typography-heading-xs-font-weight)",
		bodyXlFontFamily: "var(--typography-body-xl-font-family)",
		bodyXlFontSize: "var(--typography-body-xl-font-size)",
		bodyXlLineHeight: "var(--typography-body-xl-line-height)",
		bodyXlFontWeight: "var(--typography-body-xl-font-weight)",
		bodySmFontFamily: "var(--typography-body-sm-font-family)",
		bodySmFontSize: "var(--typography-body-sm-font-size)",
		bodySmLineHeight: "var(--typography-body-sm-line-height)",
		bodySmFontWeight: "var(--typography-body-sm-font-weight)",
		number2xlFontFamily: "var(--typography-number-2xl-font-family)",
		number2xlFontSize: "var(--typography-number-2xl-font-size)",
		number2xlLineHeight: "var(--typography-number-2xl-line-height)",
		number2xlFontWeight: "var(--typography-number-2xl-font-weight)",
		numberXlFontFamily: "var(--typography-number-xl-font-family)",
		numberXlFontSize: "var(--typography-number-xl-font-size)",
		numberXlLineHeight: "var(--typography-number-xl-line-height)",
		numberXlFontWeight: "var(--typography-number-xl-font-weight)",
		numberLgFontFamily: "var(--typography-number-lg-font-family)",
		numberLgFontSize: "var(--typography-number-lg-font-size)",
		numberLgLineHeight: "var(--typography-number-lg-line-height)",
		numberLgFontWeight: "var(--typography-number-lg-font-weight)",
		numberMdFontFamily: "var(--typography-number-md-font-family)",
		numberMdFontSize: "var(--typography-number-md-font-size)",
		numberMdLineHeight: "var(--typography-number-md-line-height)",
		numberMdFontWeight: "var(--typography-number-md-font-weight)",
		numberSmFontFamily: "var(--typography-number-sm-font-family)",
		numberSmFontSize: "var(--typography-number-sm-font-size)",
		numberSmLineHeight: "var(--typography-number-sm-line-height)",
		numberSmFontWeight: "var(--typography-number-sm-font-weight)",
		number2xsFontFamily: "var(--typography-number-2xs-font-family)",
		number2xsFontSize: "var(--typography-number-2xs-font-size)",
		number2xsLineHeight: "var(--typography-number-2xs-line-height)",
		number2xsFontWeight: "var(--typography-number-2xs-font-weight)"
	},
	ui: {
		smFontFamily: "var(--ui-sm-font-family)",
		smFontSize: "var(--ui-sm-font-size)",
		smLineHeight: "var(--ui-sm-line-height)",
		smFontWeight: "var(--ui-sm-font-weight)",
		mdFontFamily: "var(--ui-md-font-family)",
		mdFontSize: "var(--ui-md-font-size)",
		mdLineHeight: "var(--ui-md-line-height)",
		mdFontWeight: "var(--ui-md-font-weight)",
		mdStrongFontWeight: "var(--ui-md-strong-font-weight)",
		smStrongFontWeight: "var(--ui-sm-strong-font-weight)"
	},
	caption: {
		mdFontFamily: "var(--caption-md-font-family)",
		mdFontSize: "var(--caption-md-font-size)",
		mdLineHeight: "var(--caption-md-line-height)",
		mdFontWeight: "var(--caption-md-font-weight)"
	},
	label: {
		mdFontFamily: "var(--label-md-font-family)",
		mdFontSize: "var(--label-md-font-size)",
		mdLineHeight: "var(--label-md-line-height)",
		mdFontWeight: "var(--label-md-font-weight)"
	},
	button: {
		mdFontFamily: "var(--button-md-font-family)",
		mdFontSize: "var(--button-md-font-size)",
		mdLineHeight: "var(--button-md-line-height)",
		mdFontWeight: "var(--button-md-font-weight)"
	},
	tag: {
		mdFontFamily: "var(--tag-md-font-family)",
		mdFontSize: "var(--tag-md-font-size)",
		mdLineHeight: "var(--tag-md-line-height)",
		mdFontWeight: "var(--tag-md-font-weight)",
		mdLetterSpacing: "var(--tag-md-letter-spacing)"
	},
	radius: {
		none: "var(--radius-none)",
		xs: "var(--radius-xs)",
		md: "var(--radius-md)",
		lg: "var(--radius-lg)",
		xl: "var(--radius-xl)",
		"2xl": "var(--radius-2xl)",
		"4xl": "var(--radius-4xl)",
		"5xl": "var(--radius-5xl)",
		"6xl": "var(--radius-6xl)",
		full: "var(--radius-full)"
	},
	corner: {
		md: "var(--corner-md)",
		lg: "var(--corner-lg)",
		xl: "var(--corner-xl)"
	},
	partnership: {
		colorBronze: "var(--partnership-color-bronze)",
		colorSilver: "var(--partnership-color-silver)",
		colorGold: "var(--partnership-color-gold)",
		colorPlatinum: "var(--partnership-color-platinum)",
		colorXBlack: "var(--partnership-color-x-black)",
		colorXWhite: "var(--partnership-color-x-white)"
	}
}, t = {
	black: { main: "var(--color-black-main)" },
	white: { main: "var(--color-white-main)" },
	main: {
		50: "var(--color-main-50)",
		100: "var(--color-main-100)",
		200: "var(--color-main-200)",
		300: "var(--color-main-300)",
		400: "var(--color-main-400)",
		500: "var(--color-main-500)",
		600: "var(--color-main-600)",
		700: "var(--color-main-700)",
		800: "var(--color-main-800)",
		900: "var(--color-main-900)",
		950: "var(--color-main-950)",
		base: "var(--color-main-base)"
	},
	accent: {
		50: "var(--color-accent-50)",
		100: "var(--color-accent-100)",
		200: "var(--color-accent-200)",
		300: "var(--color-accent-300)",
		400: "var(--color-accent-400)",
		500: "var(--color-accent-500)",
		600: "var(--color-accent-600)",
		700: "var(--color-accent-700)",
		800: "var(--color-accent-800)",
		900: "var(--color-accent-900)",
		950: "var(--color-accent-950)",
		base: "var(--color-accent-base)"
	},
	grey: {
		50: "var(--color-grey-50)",
		100: "var(--color-grey-100)",
		200: "var(--color-grey-200)",
		300: "var(--color-grey-300)",
		400: "var(--color-grey-400)",
		500: "var(--color-grey-500)",
		600: "var(--color-grey-600)",
		700: "var(--color-grey-700)",
		800: "var(--color-grey-800)",
		900: "var(--color-grey-900)",
		950: "var(--color-grey-950)"
	},
	error: {
		50: "var(--color-error-50)",
		100: "var(--color-error-100)",
		200: "var(--color-error-200)",
		300: "var(--color-error-300)",
		400: "var(--color-error-400)",
		500: "var(--color-error-500)",
		600: "var(--color-error-600)",
		700: "var(--color-error-700)",
		800: "var(--color-error-800)",
		900: "var(--color-error-900)",
		950: "var(--color-error-950)"
	},
	warning: {
		50: "var(--color-warning-50)",
		100: "var(--color-warning-100)",
		200: "var(--color-warning-200)",
		300: "var(--color-warning-300)",
		400: "var(--color-warning-400)",
		500: "var(--color-warning-500)",
		600: "var(--color-warning-600)",
		700: "var(--color-warning-700)",
		800: "var(--color-warning-800)",
		900: "var(--color-warning-900)",
		950: "var(--color-warning-950)"
	},
	success: {
		50: "var(--color-success-50)",
		100: "var(--color-success-100)",
		200: "var(--color-success-200)",
		300: "var(--color-success-300)",
		400: "var(--color-success-400)",
		500: "var(--color-success-500)",
		600: "var(--color-success-600)",
		700: "var(--color-success-700)",
		800: "var(--color-success-800)",
		900: "var(--color-success-900)",
		950: "var(--color-success-950)"
	},
	action: {
		50: "var(--color-action-50)",
		100: "var(--color-action-100)",
		200: "var(--color-action-200)",
		300: "var(--color-action-300)",
		400: "var(--color-action-400)",
		500: "var(--color-action-500)",
		600: "var(--color-action-600)",
		700: "var(--color-action-700)",
		800: "var(--color-action-800)",
		900: "var(--color-action-900)",
		950: "var(--color-action-950)"
	},
	red: {
		50: "var(--color-red-50)",
		100: "var(--color-red-100)",
		200: "var(--color-red-200)",
		300: "var(--color-red-300)",
		400: "var(--color-red-400)",
		500: "var(--color-red-500)",
		600: "var(--color-red-600)",
		700: "var(--color-red-700)",
		800: "var(--color-red-800)",
		900: "var(--color-red-900)",
		950: "var(--color-red-950)"
	},
	purple: {
		50: "var(--color-purple-50)",
		100: "var(--color-purple-100)",
		200: "var(--color-purple-200)",
		300: "var(--color-purple-300)",
		400: "var(--color-purple-400)",
		500: "var(--color-purple-500)",
		600: "var(--color-purple-600)",
		700: "var(--color-purple-700)",
		800: "var(--color-purple-800)",
		900: "var(--color-purple-900)",
		950: "var(--color-purple-950)"
	},
	green: {
		50: "var(--color-green-50)",
		100: "var(--color-green-100)",
		200: "var(--color-green-200)",
		300: "var(--color-green-300)",
		400: "var(--color-green-400)",
		500: "var(--color-green-500)",
		600: "var(--color-green-600)",
		700: "var(--color-green-700)",
		800: "var(--color-green-800)",
		900: "var(--color-green-900)",
		950: "var(--color-green-950)"
	},
	blue: {
		50: "var(--color-blue-50)",
		100: "var(--color-blue-100)",
		200: "var(--color-blue-200)",
		300: "var(--color-blue-300)",
		400: "var(--color-blue-400)",
		500: "var(--color-blue-500)",
		600: "var(--color-blue-600)",
		700: "var(--color-blue-700)",
		800: "var(--color-blue-800)",
		900: "var(--color-blue-900)",
		950: "var(--color-blue-950)"
	},
	yellow: {
		50: "var(--color-yellow-50)",
		100: "var(--color-yellow-100)",
		200: "var(--color-yellow-200)",
		300: "var(--color-yellow-300)",
		400: "var(--color-yellow-400)",
		500: "var(--color-yellow-500)",
		600: "var(--color-yellow-600)",
		700: "var(--color-yellow-700)",
		800: "var(--color-yellow-800)",
		900: "var(--color-yellow-900)",
		950: "var(--color-yellow-950)"
	},
	orange: {
		50: "var(--color-orange-50)",
		100: "var(--color-orange-100)",
		200: "var(--color-orange-200)",
		300: "var(--color-orange-300)",
		400: "var(--color-orange-400)",
		500: "var(--color-orange-500)",
		600: "var(--color-orange-600)",
		700: "var(--color-orange-700)",
		800: "var(--color-orange-800)",
		900: "var(--color-orange-900)",
		950: "var(--color-orange-950)"
	}
}, n = {
	primary: "var(--font-family-primary)",
	display: "var(--font-family-display)",
	number: "var(--font-family-number)"
}, r = {
	xxs: "var(--spacing-xxs)",
	xs: "var(--spacing-xs)",
	sm: "var(--spacing-sm)",
	md: "var(--spacing-md)",
	ml: "var(--spacing-ml)",
	lg: "var(--spacing-lg)",
	xl: "var(--spacing-xl)",
	"2xl": "var(--spacing-2xl)",
	"3xl": "var(--spacing-3xl)",
	"4xl": "var(--spacing-4xl)",
	"5xl": "var(--spacing-5xl)",
	"6xl": "var(--spacing-6xl)",
	"7xl": "var(--spacing-7xl)",
	"8xl": "var(--spacing-8xl)",
	"9xl": "var(--spacing-9xl)",
	"10xl": "var(--spacing-10xl)",
	"11xl": "var(--spacing-11xl)"
}, i = {
	none: "var(--radius-none)",
	xxs: "var(--radius-xxs)",
	xs: "var(--radius-xs)",
	sm: "var(--radius-sm)",
	md: "var(--radius-md)",
	lg: "var(--radius-lg)",
	xl: "var(--radius-xl)",
	"2xl": "var(--radius-2xl)",
	"3xl": "var(--radius-3xl)",
	"4xl": "var(--radius-4xl)",
	"5xl": "var(--radius-5xl)",
	"6xl": "var(--radius-6xl)",
	full: "var(--radius-full)"
}, a = {
	xl: "var(--gap-xl)",
	lg: "var(--gap-lg)",
	md: "var(--gap-md)",
	sm: "var(--gap-sm)",
	xs: "var(--gap-xs)",
	"2xs": "var(--gap-2xs)",
	"3xs": "var(--gap-3xs)"
}, o = {
	"7xl": "var(--padding-7xl)",
	"6xl": "var(--padding-6xl)",
	"5xl": "var(--padding-5xl)",
	"4xl": "var(--padding-4xl)",
	"3xl": "var(--padding-3xl)",
	"2xl": "var(--padding-2xl)",
	xl: "var(--padding-xl)",
	lg: "var(--padding-lg)",
	md: "var(--padding-md)",
	sm: "var(--padding-sm)",
	xs: "var(--padding-xs)",
	"2xs": "var(--padding-2xs)",
	"3xs": "var(--padding-3xs)"
};
//#endregion
export { n as a, r as i, a as n, t as o, i as r, e as s, o as t };
